"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var warning_1 = __importDefault(require("warning"));

var TextField_1 = __importDefault(require("@material-ui/core/TextField"));

var clsx_1 = __importDefault(require("clsx"));

var TextField = function TextField(_a) {
  var _a$type = _a.type,
      type = _a$type === void 0 ? 'text' : _a$type,
      className = _a.className,
      props = __rest(_a, ["type", "className"]);

  var label = props.label,
      InputProps = props.InputProps,
      inputProps = props.inputProps,
      select = props.select,
      SelectProps = props.SelectProps;
  warning_1.default(label, 'Unifi: TextField requires a label to be present to meet accessibility best practices. For a working, accessible example, see https://unifi.nelnet.io/components/forms/text-fields');

  if (InputProps && (InputProps.startAdornment || InputProps.endAdornment)) {
    if (select) {
      warning_1.default(SelectProps && SelectProps.SelectDisplayProps && SelectProps.SelectDisplayProps['aria-label'], "Unifi: TextField as a select requires an aria-label to include the adornment value in the labels for screen readers, ex: SelectProps={{ SelectDisplayProps: { 'aria-label': 'Weight (in kilograms)'}, }}. Exception: adornment is IconButton with aria-label. For a working, accessible example, see https://unifi.nelnet.io/components/forms/text-fields#input-adornments");
    } else {
      warning_1.default(inputProps && inputProps['aria-label'], "Unifi: TextField requires an aria-label to include the adornment value in the labels for screen readers, ex: inputProps={{ 'aria-label': 'Weight (in kilograms)'}}. Exception: adornment is IconButton with aria-label. For a working, accessible example, see https://unifi.nelnet.io/components/forms/text-fields#input-adornments");
    }
  }

  var classes = clsx_1.default(className, {
    'Mui-readonly': InputProps && InputProps.readOnly
  });
  return React.createElement(TextField_1.default, Object.assign({
    type: type,
    className: classes
  }, props));
};

exports.default = TextField;